import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
  useMemo,
} from 'react';
import { InternationalAmateur } from '../data/types/internationalAmateur';

export interface InternationalAmateurMatchContext {
  isFromProfile: boolean;
  onSuccessfulAddToDrugTestRequest?: (data: InternationalAmateur) => void;
}

interface InternationalAmateurMatchContextType {
  intlMatchContext: InternationalAmateurMatchContext | null;
  setIntlMatchContext: (context: InternationalAmateurMatchContext) => void;
}

// Create the context
const InternationalAmateurMatchContext =
  createContext<InternationalAmateurMatchContextType>(undefined);

// Provider component
export const InternationalAmateurMatchProvider = ({
  children,
}: PropsWithChildren) => {
  const [intlMatchContext, setIntlMatchContext] =
    useState<InternationalAmateurMatchContext | null>(null);

  const value = useMemo(
    () => ({
      intlMatchContext,
      setIntlMatchContext,
    }),
    [intlMatchContext, setIntlMatchContext]
  );

  return (
    <InternationalAmateurMatchContext.Provider value={value}>
      {children}
    </InternationalAmateurMatchContext.Provider>
  );
};

// Hook to use the context
export const useInternationalAmateurMatchContext =
  (): InternationalAmateurMatchContextType => {
    const context = useContext(InternationalAmateurMatchContext);

    if (context === undefined) {
      throw new Error(
        'useInternationalAmateurMatchContext must be used within an InternationalAmateurMatchProvider'
      );
    }

    return context;
  };
